import "./App.css";
import "./assets/css/common.css";
import Homepage from "./layouts/main";

function App() {
    return (
        <>
            <Homepage />
        </>
    );
}

export default App;
